import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FracActivityInfo } from '../../types';

@Component({
  selector: 'lohi-frac-activity-info',
  templateUrl: './frac-activity-info.component.html',
  styleUrls: ['./frac-activity-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FracActivityInfoComponent implements OnInit {
  @Input() public fracStatus: 'running' | 'down' | 'soon';
  @Input() public title: string;
  @Input() public fracActivityInfo: FracActivityInfo[];
  @Input() public displayType: 'table' | 'list' = 'list';

  public displayedColumns: string[] = ['name', 'progressBar', 'trailerType', 'waitTime', 'viewOnMap'];

  public ngOnInit(): void { }
}
